import { useRightDrawerResizable } from '../Reporter/RightDrawer/useRightDrawer';
import { RightDrawer } from '../Reporter/RightDrawer';
import { useMemo } from 'react';
import { SlateContextProvider } from '../Reporter/SlateContext';
import { telemetryContextFor } from 'modules/Apollo/types';
import { useReporterEditorPlugins } from '../Reporter/Fields/useReporterEditorPlugins';
import { RightDrawerWrapper } from '../Reporter/RightDrawer/RightDrawerWrapper';

const BLANK_RIGHT_DRAWER_WIDTH = 500;

export const BlankRouteRightDrawer = (): React.ReactElement | null => {
  const [rightDrawerState] = useRightDrawerResizable();

  const rightDrawer = useMemo(
    () =>
      rightDrawerState?.drawerHeight !== null && (
        <RightDrawerWrapper initialSize={BLANK_RIGHT_DRAWER_WIDTH}>
          <RightDrawer.Root>
            <RightDrawer.TabSection
              disabledDoubleClick
              isSubmittedStatus={false}
              drawerHeight={rightDrawerState.drawerHeight}
            />
            <RightDrawer.PreviewOrPicklistSection />
          </RightDrawer.Root>
        </RightDrawerWrapper>
      ),
    [rightDrawerState.drawerHeight]
  );

  const plugins = useReporterEditorPlugins({
    variant: 'report',
    getActiveTemplateId: () => '',
    context: APOLLO_QUERY_CONTEXT,
  });

  return <SlateContextProvider plugins={plugins}>{rightDrawer}</SlateContextProvider>;
};

BlankRouteRightDrawer.displayName = 'BlankRouteRightDrawer';

const APOLLO_QUERY_CONTEXT = telemetryContextFor(BlankRouteRightDrawer);
